<template>
  <div class="dashboard">
    <h2 class="page-title">會員車號登記</h2>

    <!-- Registered LPs Container -->
    <div class="registered-cards">
      <div class="cards-container">
        <div class="add-card" @click="openLPModal">
          <div class="add-icon-text">
            <div class="add-icon">+</div>
            <div class="add-text">新增車號</div>
          </div>
        </div>
        <div v-if="registered_lps && registered_lps.length">
          <div v-for="lp in registered_lps" :key="lp.lpid" class="registered-card">
            <div class="card-content">
              <div class="card-details">
                <p class="lp-number">{{ lp.lpid }}</p>
                <!-- Optionally: <p class="card-number">註冊日期: {{ formatRegisterDate(lp.register_date) }}</p> -->
              </div>
              <div class="del-but-div">
                <button class="delete-button" @click="attempRemoveRegisteredLP(lp.lpid)">
                  <img src="@/assets/delete_icon.png" alt="delete" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Optionally, display a message when there are no LPs -->
      </div>
    </div>
    <!-- LP number input modal -->
    <LPNumberModal v-if="showLPModal" @lp-number-entered="lpNumberEntered" @close-modal="closeLPModal" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LPNumberModal from './LPNumberModal.vue';

export default {
  name: 'CardBoard',
  components: {
    LPNumberModal,
    // ...existing components removed for cards...
  },
  computed: {
    ...mapGetters(['user', 'registered_lps'])
  },
  data() {
    return {
      showLPModal: false
      // Removed: card/modal related state
    };
  },
  methods: {
    ...mapActions(['removeRegisteredLP', 'addToRegisteredLP']),
    openLPModal() {
      if (this.registered_lps.length >= 3) {
        alert('您最多只能登記3個車號。');
        return;
      }
      this.showLPModal = true;
    },
    closeLPModal() {
      this.showLPModal = false;
    },
    async lpNumberEntered(lpNumber) {
      // Construct LP object using the provided lpNumber.
      const lp = { id: lpNumber, plate_number: lpNumber };
      await this.$store.dispatch('addToRegisteredLP', lp);
      this.closeLPModal();
    },
    formatRegisterDate(dateStr) {
      return new Date(dateStr).toLocaleString();
    },
    attempRemoveRegisteredLP(lpId) {
      if (confirm(`您確定要移除車號 ${lpId} 嗎？`)) {
        this.removeRegisteredLP(lpId);
      }
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 0px;
  padding-bottom: 160px;
  text-align: center;

  background-color: var(--background-gray);
}



.subtitle {
  margin: 0px;
  padding: 0px;

  position: absolute;

  top: 260px;

  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray13);
  /* margin-bottom: 20px; */
}

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border: 2px dashed var(--green03); */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);


  border-radius: 20px;
  width: 638px;
  height: 182px;
  cursor: pointer;
  transition: background-color 0.2s;

  padding: 0px;
  box-sizing: border-box;
  margin: 0px;

  background-color: white;

}

.add-card:hover {
  background-color: #e6f0ff;
  border-color: var(--green02);
}

.add-icon-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.add-icon {
  font-size: 50px;
  font-weight: 200;
  color: var(--green03);
}

.add-text {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);
}

.registered-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  width: 636px;
  height: 182px;
  padding: 66px 48px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;

  box-sizing: border-box;
}

.registered-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.card-image {
  width: 240px;
  height: 150px;
  margin-right: 48px;
  /* margin-left: 10px; */
}

.card-image img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

.card-details {
  /* flex: 1; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;

  /* height: 150px; */
  height:100%;
  width:70%;
  padding-left: 20px;
  /* background-color: red; */
}

.bank-info {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin: 0px;
}


.lp-number {
  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 60px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin-top: 12px;
  margin-bottom: 12px;

}


.card-number {
  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin-top: 12px;
  margin-bottom: 48px;
}

.status {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);

  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0px;
}

.status-icon {
  width: 32px;
  height: 32px;
  margin-right: 16px;

  position: relative;
  top: -2px;
}

.del-but-div {
  /* position: relative; */
  display: flex;
  flex-direction: row;
  /* background-color: red; */
  /* border: 1px solid red; */
  /* margin:auto 0px; */
}

.delete-button {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  transition: color 0.2s;
}

.delete-button img {
  width: 48px;
  height: 48px;
}

.delete-button:hover img {
  filter: brightness(0.8);
}

/* Responsive Styles for screens smaller than 560px */
@media (max-width: 560px) {

  .cards-container {
    width: 343px;
    gap: 12px;

    margin: 0 auto;
  }

  .add-card {
    padding: 0px;
  }

  .add-card,
  .registered-card {
    width: 343px;
    height: 80px;
    /* border-radius: 8px; */

    box-sizing: border-box;
  }

  .subtitle {
    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    position: static;
    top: 0px;

  }



  .add-icon-text {
    gap: 8px;
  }

  .add-icon {
    /* //styleName: sm/bold; */
    font-size: 30px;
    margin-right: 0px;

  }

  .add-text {
    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }



  .registered-card {
    padding: 20px 12px;
    flex-direction: row;
    align-items: center;
  }

  .card-content {
    flex-direction: row;

  }

  .card-image {
    width: 64px;
    height: 40px;

    /* margin-bottom: 10px;
     */
    margin: 0;
    margin-right: 8px;
  }

  .card-image img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .card-details {
    text-align: left;
    padding-left: 30px;
  }

  .bank-info {

    /* //styleName: xs/bold; */
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }

  .lp-number {
    font-size: 30px;
    margin: auto 0px;
  }

  .card-number,
  .status {
    /* //styleName: xs/regular; */
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 4px;
  }

  .delete-button {
    /* position: relative; */
    /* align-self: flex-end; */
    /* margin-top: 10px; */
    right: 16px;
  }

  .delete-button img {
    width: 24px;
    height: 24px;
  }

  .status {
    display: none;
  }
}
</style>
